// extracted by mini-css-extract-plugin
export default {"container":"GenericSelect_container__o-uTZ"};